import EnlilAxiosRestAPI from "../../../../util/EnlilAxiosRestAPI";
import EnterpriseComponent from "../../EnterpriseComponent";
import {V1AdminPrivilegeIDOCToArray} from "../../../../util/Payload";
import MemoryContext from "../../../../util/MemoryContext";
import {v4 as uuidv4} from "uuid";

class AdminPrivilegeEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, _) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocResponse = this.getIDOCResponse() ?? "v1.AdminPrivilege-001";

        EnlilAxiosRestAPI({
            method: "GET",
            url: "t3/v1/admin_privileges",
            json: true,
            params: {
                "Limit": pageSize,
                "Offset": (page - 1) * pageSize,
                "Sort": this.getFormattedSortSpecification(),
                "Name": this.getAttributeValue("Name"),
                "ParentUSID": this.getAttributeValue("ParentUSID"),
            },
            headers: {
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1AdminPrivilegeIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

}

export default AdminPrivilegeEnterpriseComponent;